// Verze aplikace – posílá se do zpětné vazby kvůli triage. Aktualizuj při releasu.
export const APP_VERSION = '2.16.3';
